import script from "./DetalleSopelaKostaFestView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalleSopelaKostaFestView.vue?vue&type=script&setup=true&lang=js"

import "./DetalleSopelaKostaFestView.vue?vue&type=style&index=0&id=13748250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13748250"]])

export default __exports__